















import { Vue, Prop, Watch, Component } from "vue-property-decorator";
import { Controlador as Model, ControladorDeCurso } from '../curso-controlador';
import opcion from './curso-resultado-pregunta-opcion.vue';
import { Curso } from '@/__env/lib/Cursos';
import { Resultado } from '@/__env/lib/Cursos/Resultado';
import { Pregunta } from '@/__env/lib/Cursos/Preguntas';
import { Respuesta } from '@/__env/lib/Cursos/Respuestas';
import { OpcionElegida } from '@/__env/lib/Cursos/Respuestas/Respuesta.lib';
@Component( {
    name: "Componente",
    props: {},
    components: {
        opcion,
    }
} )
export default class Componente extends Vue
{
    public get Controlador(): ControladorDeCurso { return Model; }
    public get Curso(): Curso { return Model.Curso; }
    public get Resultado(): Resultado { return Model.Resultado; }

    @Prop()
    public Pregunta: Pregunta;

    public get Respuesta(): Respuesta
    {
        return this.Resultado.Respuestas.find( x => x.Pregunta == this.Pregunta.Id );
    }

    public buscarOpcion( id: number ): OpcionElegida
    {
        return this.Respuesta.OpcionesElegidas.find( x => x.Opcion == id );
    }

    async mounted()
    {

    }
}
